<template>
  <div class="animated fadeIn">
    <component-header
      title="Approvals"
      @search-query="(val) => (filter = val)"
      :isLoading="loading"
      @reload-data="getApprovalsList"
      :hasback="false"
      :hasCreate="false"
    />
    <b-card class="card-wrap" border-variant="info" style="min-height: 450px">
      <b-row>
        <b-col md="3" class="my-1">
          <b-form-group label-cols-sm="3" class="mb-0">
            <label>Time Period</label>
            <eb-select
              type="select"
              v-model="selectedPeriod"
              :options="periodList"
              label="text"
              :id="'selecttime'"
              :selected="selectedPeriod"
              @input="changePeriod"
            ></eb-select>
          </b-form-group>
        </b-col>
        <b-col md="3" class="my-1">
          <b-form-group label-cols-sm="3" class="mb-0">
            <label>Select Dealer</label>
            <eb-select
              type="select"
              v-model="selectedProvider"
              :options="partnerList"
              label="dealerName"
              :id="'selectdealer'"
              placeholder="Select Dealer"
              :selected="selectedProvider"
              @input="changeProvider"
            ></eb-select>
          </b-form-group>
        </b-col>
        <b-col md="3" class="my-1">
          <b-form-group label-cols-sm="3" class="mb-0">
            <label>Status</label>
            <eb-select
              type="select"
              v-model="selectedStatus"
              :options="['PENDING', 'APPROVED', 'REJECTED']"
              :id="'selectdealer'"
              :selected="selectedStatus"
              placeholder="Select Status"
              @input="changeProvider"
            ></eb-select>
          </b-form-group>
        </b-col>
      </b-row>
      <div>
        <b-table
          :fields="Columns"
          :items="approvalData"
          :dark="false"
          :filter="filter"
          :hover="true"
          thead-class="header"
          :striped="false"
          :bordered="true"
          :current-page="currentPage"
          :per-page="perPage"
          :small="false"
          show-empty
          :fixed="false"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
        >
          <template slot="action" slot-scope="data">
            <b-button
              size="sm"
              class="mr-2"
              variant="primary"
              @click="viewApproval(data.item)"
            >
              <i class="fa fa-eye"></i>
            </b-button>
          </template>
          <template slot="createdAt" slot-scope="data">
            <div>{{ data.item.createdAt | formatedate }}</div>
          </template>
          <template slot="updatedAt" slot-scope="data">
            <div>{{ data.item.updatedAt | formatedate }}</div>
          </template>
          <template slot="empty">
            <div v-if="loading" class="text-center">
              <span><b>Loading...</b></span>
            </div>
            <div v-else class="text-center">No data available.</div>
          </template>
        </b-table>
      </div>
      <div style="float: right">
        <b-pagination
          v-model="currentPage"
          :per-page="perPage"
          :total-rows="approvalData.length"
          aria-controls="my-table"
          prev-text="Prev"
          next-text="Next"
        ></b-pagination>
      </div>
    </b-card>
  </div>
</template>
<script>
import ebButton from "@/components/FormElements/Button";
import ebSelect from "@/components/FormElements/Select.vue";
import ComponentHeader from "@/components/componentHeader";
import loader from "@/components/loader/nipigeloader.vue";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";

export default {
  name: "Approval",
  components: {
    ebButton,
    ebSelect,
    loader,
    ComponentHeader,
  },
  data() {
    return {
      sortBy: "createdAt",
      sortDesc: true,
      loading: false,
      isloading: false,
      currentPage: 1,
      filter: "",
      perPage: 10,
      selectedStatus: "PENDING",
      periodList: [
        {
          text: "Last 7 days",
          value: 7,
        },
        {
          text: "Last 15 days",
          value: 15,
        },
        {
          text: "Last 30 days",
          value: 30,
        },
        {
          text: "Last 3 Months",
          value: 90,
        },
        {
          text: "Last 6 Months",
          value: 180,
        },
      ],
      Columns: [
        {
          key: "approvalType",
          label: "Approval Type",
        },
        {
          key: "createdAt",
          label: "Create Date",
        },
        {
          key: "provider.category",
          label: "Category",
        },
        {
          key: "createdBy.name",
          label: "Dealer",
        },
        {
          key: "provider.organization.name",
          label: "Agent",
        },
        {
          key: "status",
          label: "Status",
        },
        {
          key: "action",
          label: "Action",
        },
      ],
      selectedPeriod: {
        text: "Last 7 days",
        value: 7,
      },
      selectedProvider: { dealerName: "All", _id: "" },
    };
  },
  computed: {
    approvalData() {
      let dataList = this.$store.getters["partner/GetApprovalsList"];
      if (dataList.length > 0) {
        return dataList.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
      } else {
        return [];
      }
    },
    partnerList() {
      let data = this.$store.getters["partner/GetPartnerLiteList"];
      if (data.length > 0) {
        let partners = [];
        data.map((obj) => {
          partners.push({ ...obj, dealerName: obj.organization.name });
        });
        partners.unshift({ dealerName: "All", _id: "" });
        return partners;
      }
    },
  },
  methods: {
    ...mapActions({
      GetPartnerList: "partner/fetchPartnerListLite",
    }),
    getApprovalsList() {
      this.loading = true;
      let payload = `status=${this.selectedStatus}&dealerId=${
        this.selectedProvider ? this.selectedProvider._id : ""
      }&n=${this.selectedPeriod.value}`;
      this.$store
        .dispatch("partner/getApprovalList", payload)
        .then((data) => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    changePeriod(event) {
      this.getApprovalsList();
    },
    changeProvider() {
      this.getApprovalsList();
    },
    async viewApproval(data) {
      this.$router.push({ name: "ApprovalView", params: { userData: data } });
    },
  },
  mounted() {
    this.getApprovalsList();
    this.GetPartnerList({ type: "DEALER" });
  },
  filters: {
    formatedate: function (value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY hh:mm A");
      }
    },
  },
};
</script>

<style>
table.b-table[aria-busy="true"] {
  opacity: 0.6;
}
.modal-header h5 {
  color: white;
}
</style>
